/**
 * Identité légale de l'éditeur, affichée dans les mentions légales, les CGU/CGV
 * et la politique de confidentialité. Une valeur `null` s'affiche « à compléter » :
 * les pages ne doivent pas être mises en ligne tant qu'il en reste une.
 */
export const LEGAL = {
    /**
     * Éditeur, tel qu'il doit être désigné : entreprise individuelle, donc le nom
     * de l'entrepreneur suivi de « EI » (art. L. 526-22 du Code de commerce).
     */
    companyName: 'Samuel Gabillard EI',
    /** Nom commercial sous lequel l'activité est exercée. */
    tradeName: 'Yakafa',
    /** Entrepreneur individuel : représentant légal et directeur de la publication. */
    ownerName: 'Samuel Gabillard',
    legalForm: 'Entreprise individuelle (EI)',
    /** Sans objet pour une entreprise individuelle (pas de capital social). */
    shareCapital: 'sans objet',
    /** Adresse de l'établissement (domiciliation). */
    address: '25 rue des Vinaigriers, 75010 Paris',
    /** Depuis 2023, toute entreprise individuelle est inscrite au Registre national des entreprises (RNE). */
    registration: 'Registre national des entreprises (RNE), SIREN 131 660 185',
    /** SIRET du siège : sert aussi aux factures d'abonnement et aux pages d'aide. */
    siret: '13166018500011',
    /** Clé vérifiée : (12 + 3 × (SIREN mod 97)) mod 97 = 59. */
    vatNumber: 'FR59131660185',
    /** Directeur de la publication : l'entrepreneur lui-même. */
    publicationDirector: 'Samuel Gabillard',
    contactEmail: 'contact@yakafa.fr',
    /** Assistance des utilisateurs (redirigée, comme contact@ et dpo@, par ImprovMX). */
    supportEmail: 'support@yakafa.fr',
    /** Adresse dédiée aux demandes RGPD (peut être la même que le contact). */
    privacyEmail: 'dpo@yakafa.fr',
    /** Tribunal compétent pour les litiges entre professionnels. */
    court: null,
    /** Date de dernière mise à jour des documents (YYYY-MM-DD). */
    updatedOn: '2026-11-04',
};
/** Hébergeur de l'application (VM EC2, région eu-west-1 — Irlande). */
export const HOSTING = {
    // Depuis le 2026-10-13 (migration de la VM AWS Dublin). Adresse : facture Cherry Servers.
    name: 'UAB Cherry Servers',
    address: 'Tilžės g. 74-320, 78140 Šiauliai, Lituanie',
    location: 'Allemagne (Francfort)',
    website: 'https://www.cherryservers.com',
};
/** Champs d'identité encore manquants : à vérifier avant toute mise en ligne. */
export function missingLegalFields() {
    return [...Object.entries(LEGAL), ...Object.entries(HOSTING).map(([key, value]) => [`hosting.${key}`, value])]
        .filter(([, value]) => value === null)
        .map(([key]) => key);
}
//# sourceMappingURL=legal.js.map